import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // Import your CSS file if you have one

const Tests = () => {
  return (
    <div className="home-container">
      <header className="home-header">
        <h1>Tests</h1>
        <p>Select a page to visit:</p>
      </header>
      <main className="home-content">
        <nav className="home-nav">
          <ul>
            <li>
              <Link to="/create_test">Create Test</Link>
            </li>
            <li>
              <Link to="/create_test_record">Create Test Record</Link>
            </li>
            <li>
              <Link to="/view_test">View Tests</Link>
            </li>
            <li>
              <Link to="/view_test_records">View Test Records</Link>
            </li>
            <li>
              <Link to="/filter_test">Filter Test Records</Link>
            </li>
            <li>
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to="/">Log-out</Link>
            </li>
          </ul>
        </nav>
      </main>
    </div>
  );
}

export default Tests;
